import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class WorkflowService {
    private urlModulo = `${environment.urlAPI}/workflow`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera as ações possíveis para a estação (somente as ações permitidas ao usuário)
     * @param codEstacao Código da configuração da estação
     * @param codUsuario Código do usuário (opcional)
     */
    public getAcoesByEstacao(codEstacao: number, codUsuario?: number): Promise<any> {
        let params = new HttpParams().set('codEstacao', codEstacao.toString());
        
        if (codUsuario) {
            params = params.append('codUsuario', codUsuario.toString());
        }
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-acoesByCodEstacao`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.acoes);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera todas as ações possíveis para a aprovação do auditor
     */
    public getAcoesAprovacaoAuditor(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-acoesAprovacaoAuditor`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.acoes);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera as Informações para Tela Solicitação
     * @param codWorkflow Código do workflow
     */
    public getInfoWorkflowCx(codWorkflow: number): Promise<any> {
        const params = new HttpParams().set('codWorkflow', codWorkflow.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-infoWorkflowCx`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.info);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera as informações possíveis para a estação
     * @param codWorkflow Código do workflow
     */
    public getInfoWorkflow(codWorkflow: number): Promise<any> {
        const params = new HttpParams().set('codWorkflow', codWorkflow.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-infoWorkflow`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.acoes);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera as informações do workflow na estação solicitada
     * @param codWorkflow Código do workflow
     * @param codEstacao Código da estação
     */
    public getInfoWorkflowByEstacao(codWorkflow: number, codEstacao: string): Promise<any> {
        const params = new HttpParams()
            .set('codWorkflow', codWorkflow.toString())
            .set('codEstacao', codEstacao);
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-infoWorkflowByEstacao`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.workflow);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera as informações do workflow para execução da auditoria
     * @param codWorkflow Código do workflow em andamento
     */
    public getInfoWorkflowAuditoria(codWorkflow: number): Promise<any> {
        const params = new HttpParams().set('codWorkflow', codWorkflow.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-infoWorkflowAuditoria`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.workflow);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera a estação do workflow pelo autor
     * @param codAutor Código do autor
     */
    public getEstacaoWorkflowByAutor(codAutor: number): Promise<any> {
        const params = new HttpParams().set('codAutor', codAutor.toString());
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-estacaoByCodAutor`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.acoes);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera o código do workflow do autor para o sistema de gestão
     * @param codAutor Código do autor
     * @param codSistemaGestao Código do sistema de gestão
     */
    public getCodWorkflowByAutorSistemaGestao(codAutor: number, codSistemaGestao: number): Promise<any> {
        const params = new HttpParams()
            .set('codAutor', codAutor.toString())
            .set('codSistemaGestao', codSistemaGestao.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-infoWorkflowSistemaGestao`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Grava uma ação no workflow
     * @param obj Dados da ação
     */
    public gravaAcao(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-gravaacao`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Atualiza arquivo da ação
     * @param obj Dados do arquivo
     */
    public atualizarArquivoAcao(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-atualizaarquivo`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Atualiza workflow de solicitação
     * @param obj Dados do workflow
     */
    public atualizarWorkflowSolicitacao(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-atualizarWorkflowSolicitacao`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Atualiza informações do workflow
     * @param obj Dados de informações
     */
    public atualizaWorkflowInfo(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-atualizarWorkflowInfo`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Atualiza histórico do workflow
     * @param obj Dados do histórico
     */
    public atualizaWorkflowHistorico(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-atualizarWorkflowHistorico`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Fecha uma estação do workflow
     * @param obj Dados da estação
     */
    public fecharEstacao(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-fecharEstacao`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Inicia workflow de auditoria fase 2
     * @param obj Dados do workflow
     */
    public iniciarWorkflowAuditoriaFase2(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-iniciaWorkflowAuditoriaFaseII`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Inicia workflow de arquivo de certificado
     * @param obj Dados do certificado
     */
    public iniciaWorkflowArquivoCertificado(obj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-iniciaWorkflowArquivoCertificado`, obj)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Analisa pesquisa de satisfação
     * @param codAutor Código do autor
     * @param codSistemaGestao Código do sistema de gestão
     */
    public analisePesquisaSatisfacao(codAutor: number, codSistemaGestao: number): Promise<any> {
        const payload = {
            codAutor: codAutor,
            codSistemaGestao: codSistemaGestao
        };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-analisaPesquisa`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Envia pesquisa de satisfação
     * @param codAutor Código do autor
     * @param codSistemaGestao Código do sistema de gestão
     */
    public enviaPesquisaSatisfacao(codAutor: number, codSistemaGestao: number): Promise<any> {
        const payload = {
            codAutor: codAutor,
            codSistemaGestao: codSistemaGestao
        };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-enviaPesquisa`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera descrição do histórico do workflow
     * @param codWorkflowHistorico Código do histórico do workflow
     */
    public descricaoWorkflowHistorico(codWorkflowHistorico: number): Promise<any> {
        const params = new HttpParams().set('codWorkflowHistorico', codWorkflowHistorico.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-infoWorkflowHistorico`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Registra desistência de desenvolvimento pelo usuário
     * @param codUsuario Código do usuário
     * @param codSistemaGestao Código do sistema de gestão
     */
    public desistenciaDesenvolvimentoByCodUsuario(codUsuario: number, codSistemaGestao: number): Promise<any> {
        const payload = {
            codUsuario: codUsuario,
            codSistemaGestao: codSistemaGestao
        };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-finalizaWorkflowSolicitacaoDesistencia`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Cancela certificados do fornecedor
     * @param codAutor Código do autor
     * @param codSistemaGestao Código do sistema de gestão
     * @param codCertificado Código do certificado
     * @param codMotivo Código do motivo
     */
    public cancelaCertificados(codAutor: number, codSistemaGestao: number, codCertificado: number, codMotivo: number): Promise<any> {
        const params = new HttpParams()
            .set('codAutor', codAutor.toString())
            .set('codSistemaGestao', codSistemaGestao.toString())
            .set('codCertificado', codCertificado.toString())
            .set('codMotivo', codMotivo.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-cancelaCertificadoFornecedor`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Grava auditor responsável pelo workflow
     * @param codWorkflow Código do workflow
     * @param codAuditorLider Código do auditor líder
     */
    public gravaAuditorWorkflow(codWorkflow: number, codAuditorLider: number): Promise<any> {
        const payload = {
            codWorkflow: codWorkflow,
            codAuditorLider: codAuditorLider
        };
        
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-gravaAuditorWorkflow`, payload)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Lista executores das estações abertas 8 e 11 do workflow
     */
    public getExecutorEstacoesAbertasFase2(
        codWorkflow: number
    ): Promise<Array<{ codEstacao: number; codUsuarioExecutante: number }>> {
        const params = new HttpParams().set('codWorkflow', codWorkflow.toString());

        return new Promise((resolve, reject) => {
            this.http
                .get(`${this.urlModulo}-executorEstacoesAbertasFase2`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    },
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/workflow.service.ts